import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";


export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 24px 0; /* evita ficar colado no topo e no rodapé */
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr{
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary{
    background-color: #05367f;
    display: block;
    border: 0px;
    width: 100%;
  }

  .card {
    margin: 15px 0px;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(30, 136, 229, 0.1);

  .pull-right{
    position: relative;
    float: right;
  }
`;


export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

// FAQ Components
export const FAQSection = styled.section`
  padding: 3rem 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  position: relative;
`;

export const FAQContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const FAQTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 900;
  background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-align: center;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const FAQSubtitle = styled.p`
  font-size: 1.2rem;
  color: #4a5568;
  text-align: center;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }
`;

export const FAQContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FAQItem = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(30, 136, 229, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(30, 136, 229, 0.15);
  }
`;

export const FAQQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, rgba(30, 136, 229, 0.02) 0%, rgba(25, 118, 210, 0.02) 100%);
  
  &:hover {
    background: linear-gradient(135deg, rgba(30, 136, 229, 0.05) 0%, rgba(25, 118, 210, 0.05) 100%);
  }
  
  @media (max-width: 768px) {
    padding: 1.5rem;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const FAQQuestionText = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  flex: 1;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    line-height: 1.4;
  }
`;

interface FAQIconProps {
  isOpen?: boolean;
}

export const FAQIcon = styled.div<FAQIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
  color: white;
  transition: all 0.3s ease;
  flex-shrink: 0;
  
  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
  
  ${FAQItem}:hover & {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    width: 35px;
    height: 35px;
    margin-top: 0.2rem;
    
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const FAQAnswer = styled.div`
  padding: 0 2rem 2rem;
  border-top: 1px solid rgba(30, 136, 229, 0.1);
  background: rgba(30, 136, 229, 0.02);
  
  @media (max-width: 768px) {
    padding: 0 1.5rem 1.5rem;
  }
`;

export const FAQAnswerText = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.7;
  margin: 0;
  padding-top: 1.5rem;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    padding-top: 1rem;
  }
`;

